module.exports = __webpack_public_path__ + "bglogindark.png";